import React, { useState } from 'react';

import { IWidgetWrap } from '../../../types/IWidgetWrap';
import ChartWidget from '../../../../dashboards/components/widget/chartWidget/chartWidget';
import GridWidget from '../../../../dashboards/components/widget/gridWidget/gridWidget';
import SummaryWidget from '../../../../dashboards/components/widget/summaryWidget/summaryWidget';
import TreeListWidget from '../../../../dashboards/components/widget/treeListWidget/treeListWidget';
import MapWidget from '../../../../dashboards/components/widget/mapWidget/mapWidget';

import '../widgetPinSection.scss';

const WidgetWrap: React.FC<IWidgetWrap> = ({id, widget, widgets, handleUnpin, customisation, handleWidgetMove, handleWidgetChange, changeNewIndex, changeOldIndex}) => {
  const [expand, setExpand] = useState<boolean>(false);

  const onExpand = (): void => {
    setExpand(true);
  };

  const onCollapse = (): void => {
    setExpand(false);
  };

  const components = {
    chart: ChartWidget,
    grid: GridWidget,
    summary: SummaryWidget,
    treelist: TreeListWidget,
    map: MapWidget,
  };

  const WidgetComponent = components[widget.type];

  return (
    <div key={id} className={`widget-wrap ${expand ? 'expand-widget' : ''}`}>
      <WidgetComponent
        scenarios={widget.scenarios}
        widget={widget.widget}
        setup={widget.setup}
        expand={expand}
        onCollapse={onCollapse}
        onExpand={onExpand}
        measures={widget.measures}
        key={widget.widget.id}
        periods={widget.periods}
        notes={widget.notes}
        boardId={widget.boardId}
        id={widget.widget.id}
        staticProperties={widget.staticProperties}
        customisation={customisation}
        widgets={widgets}
        handleWidgetChange={handleWidgetChange}
        handleWidgetMove={handleWidgetMove}
        changeNewIndex={changeNewIndex}
        changeOldIndex={changeOldIndex}
        selectedObject={widget.selectedObject}
        selectedPeriod={widget.selectedPeriod}
        boardSelectedCurrency={widget.boardSelectedCurrency}
        investorObjectId={widget.investorObjectId}
        homePage={widget.homePage}
        handleUnpin={handleUnpin}
        unpinId={widget.unpinId}
      />
    </div>
  );
};

export default WidgetWrap;